export const redirectionAfterMaintenance = (settings) => {
  if (settings?.maintenance && settings?.maintenanceLevel === 5) {
    if (window.location.pathname !== "/maintenance") {
      window.location.href = "/maintenance";
    }
  }
  if (
    window.location.pathname === "/maintenance" &&
    settings?.maintenanceLevel !== 5
  ) {
    window.location.href = "/";
  }
};
